import React from 'react';
import { BrushIcon, GraduationCapIcon, PresentationIcon, SchoolIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { audience } from '../../data/content';
const icons = [GraduationCapIcon, PresentationIcon, SchoolIcon, BrushIcon];
const tints = ['#F6D5D0', '#DDE9DC', '#D9ECF8', '#E9DDF4'];
export function AudienceSection() {
  return <section aria-labelledby="audience-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-45" data-mp="286t3b8wr2wzy">
      <div className="mx-auto max-w-5xl" data-id="element-46" data-mp="237yade52js24">
        <SectionHeading id="audience-heading" title={<>
              Created for PMU Professionals <Accent data-id="element-48" data-mp="2h17gn5xpzxgf">Who Teach</Accent>
            </>} data-id="element-47" data-mp="236x03bvvn9lg" />

        <ul className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" role="list" data-id="element-49" data-mp="2cysxekq52vom">
          {audience.map((item, index) => {
          const Icon = icons[index];
          return <li key={item.title} className="flex flex-col items-center rounded-[20px] bg-white px-5 py-7 text-center" data-id="element-50" data-mp="2lz9380ucuewn" data-mpi={index}>
                <span className="flex h-12 w-12 items-center justify-center rounded-full" style={{
              backgroundColor: tints[index]
            }} data-id="element-51" data-mp="1sdf4u64msnb9">
                  <Icon className="h-5 w-5 text-brand-charcoal" strokeWidth={1.5} aria-hidden="true" data-id="element-52" data-mp="2287196mh944g" />
                </span>
                <h3 className="mt-4 font-display text-[1.2rem] font-bold leading-tight text-brand-charcoal" data-id="element-53" data-mp="26993lwboxwan">
                  {item.title}
                </h3>
                <p className="mt-2 text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-54" data-mp="2g8hwelutl4vf">{item.text}</p>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-10 max-w-2xl text-center text-[13px] leading-relaxed text-brand-charcoal/60" data-id="element-55" data-mp="2pzcqgceb58rf">
          Educational resources should be adapted to your qualifications, local regulations, and training
          requirements.
        </p>
      </div>
    </section>;
}